package com.nonopn.skywatcher.common.app.pages.map.model.weather

import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetection
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import kotlin.math.abs

data class ThunderActivityInfo(
    val strongest: ThunderDetectionActivity,
    val strongestDistance: Double,
    val closest: ThunderDetectionActivity,
    val closestDistance: Double
) {
    companion object {
        fun from(
            detection: ThunderDetectionWithMetadata,
            activities: List<ThunderDetectionActivity>?
        ): ThunderActivityInfo? {
            /*return ThunderActivityInfo(
                closest = ThunderDetectionActivity(
                    pulsePeakAmp = 23000,
                ),
                closestDistance = 21.0,
                strongest = ThunderDetectionActivity(
                    pulsePeakAmp = 49000
                ),
                strongestDistance = 48.0
            )*/
            if (activities.isNullOrEmpty()) return null

            var closestKm: Double = Double.MAX_VALUE
            var strongestDistance: Double = Double.MIN_VALUE
            var strongestAmp: Int = Int.MIN_VALUE

            var closest: ThunderDetectionActivity? = null
            var strongest: ThunderDetectionActivity? = null

            activities.forEach {
                val distance = it.distance(detection.detection.position())

                if (null == closest || closestKm > distance) {
                    closest = it
                    closestKm = distance
                }

                if (null == strongest || strongestAmp < abs(it.pulsePeakAmp)) {
                    strongest = it
                    strongestAmp = abs(it.pulsePeakAmp)
                    strongestDistance = distance
                }
            }

            return ThunderActivityInfo(
                strongest = strongest!!,
                closest = closest!!,
                closestDistance = closestKm,
                strongestDistance = strongestDistance
            )
        }
    }
}